




























































import { ZenyaDialogComponent, ZenyaDialogInjects } from "../dialogs/ZenyaDialog.vue";
import storeHelper from "./../../store/store-helper";
import tasks from "@/store/modules/tasks/tasks";
import { Task } from "@/tasks";
import moment, { parseTwoDigitYear } from "moment";
import i18n from "./../../plugins/i18n";
import { SiteState } from "@/store/modules/site";
import { TaskPostPoneDialogOption } from "../../enums";
import Utils from "@/utils";
import InfolandDatePicker from "@/components/generic/infoland-date-picker.vue";

export default ZenyaDialogComponent.extend({
    inject: ZenyaDialogInjects,
    name: "PostponeDialog",
    components: { InfolandDatePicker },
    props: {
        postponeUntilDate: Date,
        multiEdit: Boolean
    },
    data: () => {
        return {
            postponeUntilOption: TaskPostPoneDialogOption.CustomDate as string,
            tomorrowString: null as string,
            nextWeek: null as moment.Moment,
            inTwoWeeks: null as moment.Moment,
            localFormat: i18n.locale as string,
            postponeOptions: TaskPostPoneDialogOption as any,
            datepickerString: null as string
        };
    },
    computed: {
        formattedPostponeUntilDate(): string {
            return this.datepickerString ? Utils.formatDate(new Date(this.datepickerString), this.$user?.date_format) : null;
        }
    },
    created() {
        //connect handlers to be called when ok/cancel is clicked in the dialog
        this.registerHandlers({ ok: this.onOk });

        //new Date() in these 2 spots because Date props are passed through as strings due to some serialization issues
        if (this.postponeUntilDate && moment(new Date(this.postponeUntilDate)).year() == 3000) this.postponeUntilOption = "maxDate";
        this.datepickerString = this.postponeUntilDate ? Utils.getDatePickerString(new Date(this.postponeUntilDate)) : null;

        const tomorrow = moment().add(1, "day");
        this.tomorrowString = tomorrow.format("YYYY-MM-DD");
        this.nextWeek = moment().add(1, "week");
        this.inTwoWeeks = moment().add(2, "week");
    },
    mounted() {
        //Fix IE problem that caused first radio button to always be highlighted
        (document.activeElement as any).blur();
    },
    methods: {
        async onOk() {
            await this.updatePostponeUntilAsync();
            return true;
        },
        async updatePostponeUntilAsync() {
            let newPostponeValue = null as moment.Moment;

            switch (this.postponeUntilOption) {
                case TaskPostPoneDialogOption.Week:
                    newPostponeValue = this.nextWeek;
                    break;
                case TaskPostPoneDialogOption.TwoWeeks:
                    newPostponeValue = this.inTwoWeeks;
                    break;
                case TaskPostPoneDialogOption.MaxDate:
                    newPostponeValue = moment("3000-01-01");
                    break;
                case TaskPostPoneDialogOption.RemovePostponeDate:
                    newPostponeValue = null;
                    break;
                case TaskPostPoneDialogOption.CustomDate:
                    newPostponeValue = moment(this.datepickerString);
                    break;
                default:
                    break;
            }

            const newPostponedDate = newPostponeValue != null ? newPostponeValue.toDate() : null;
            this.$emit("changed", newPostponedDate);
        },
        dateToUserFormat(momentDate: moment.Moment): string {
            return Utils.formatDate(momentDate.toDate(), this.$user?.date_format);
        }
    }
});
